import { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { NewHeader } from "./components/new_header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Faqs } from "./components/faqs";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

    return (
        <div>
        <Navigation />
        <NewHeader />
        <About data={landingPageData.About} />
        <Services data={landingPageData.Services} />
        <Faqs data={landingPageData.Faqs}/>
        <Contact data={landingPageData.Contact} />
        </div>
    );
};

export default App;
